export default class EntitySeasonsSelectModel {
	seasonId: string = '';
	seasonName: string = '';
	tournamentName: string = '';
	tournamentId: string = '';
}
